// extracted by mini-css-extract-plugin
module.exports = {"subtitleContainer":"styles_subtitleContainer__3e8lM"};